const objectParamTypes = [
  'TEXT', 'TEXT_AREA', 'DATE'
];
export default objectParamTypes;